import { render } from "./html.vue?vue&type=template&id=18b6f49d"
import script from "./html.vue?vue&type=script&lang=js"
export * from "./html.vue?vue&type=script&lang=js"

import "./html.vue?vue&type=style&index=0&id=18b6f49d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__